import React from 'react';
import { DeviceActionProps } from './DeviceActions';
import { ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlarmIcon } from '../../../../../../theme/icons';
import { getPolyglot } from '../../../../../../i18n';
import { useAppSelector } from '../../../../../../redux/store.model';
import {
  ButtonIcon,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import { getAlarmActiveBySelector } from '../../../../../../redux/incident/selectors/getAlarmActiveBySelector';
import showAlarmsSelector from '../../../../../../redux/incident/selectors/showAlarmsSelector';
import useModuleSelected from '../../../../navigations/useModuleSelected';
import { NotificationIcon } from './NotificationIcon';
import { useGetMQTTDeviceConnection } from '../../../../../../redux/commander/hooks/useGetMQTTDeviceConnection';
import { getDictionaryGroups } from '../../../../../../redux/groups/selectors';

const iconId = 'alarms';
const icon = <AlarmIcon height={'1em'} />;
/**
 * Show the current numbers of alarms active in the device
 * Open all alarms of the device
 */
export function DeviceAlarmsAction(props: DeviceActionProps) {
  const { device, groupId, variant } = props;
  const deviceId = device.uuid;
  const polyglot = getPolyglot();
  const navigate = useNavigate();
  const featureToggle = useAppSelector((state) => state.featureToggle);
  const myGroups = useAppSelector(getDictionaryGroups);
  const deviceInGroup = Object.values(myGroups)?.find((g) =>
    g?.devices?.includes(device.uuid)
  );
  const { data: alarmsActive, isLoading: isLoadingAlarmsActive } =
    useAppSelector((state) =>
      getAlarmActiveBySelector(state, {
        deviceId,
      })
    );

  const showAlarms = useAppSelector(showAlarmsSelector);

  const onClick = (e: React.MouseEvent) => {
    let url = `/devicemanager/device/${deviceId}/device-detail/alarms`;
    if (groupId) {
      url = `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/alarms`;
    }
    if (featureToggle.styledComponentsVariants === 'fresh-watch') {
      if (deviceInGroup) {
        url = `/merchandiser/${deviceInGroup.parentGroupId}`;
      } else if (groupId) {
        url = `/merchandiser/${groupId}`;
      }
    }

    navigate(url);
  };

  const moduleSelected = useModuleSelected();
  const selected = moduleSelected === 'alarms';

  let tooltipContent = polyglot.t('incident.all_alarms');

  const { cloudConnectivityMQTT } = useGetMQTTDeviceConnection(device);

  if (!cloudConnectivityMQTT) {
    tooltipContent = polyglot.t('incident.limited_alarms_info');
  }

  if (!showAlarms) return null;

  return (
    <React.Fragment>
      {variant === 'menuItem' ? (
        <MenuItemPrimary
          onClick={onClick}
          className={`icon-${iconId} device-${deviceId}`}
          selected={selected}
        >
          <ListItemIcon sx={{ color: 'inherit' }}>
            <NotificationIcon
              isMobileDevice={variant === 'menuItem'}
              device={device}
            />
            {icon}
          </ListItemIcon>
          {tooltipContent}
        </MenuItemPrimary>
      ) : (
        <ButtonIcon
          className={`icon-${iconId} device-${deviceId}`}
          tooltip={tooltipContent}
          onClick={onClick}
          loading={isLoadingAlarmsActive}
          badge={alarmsActive.length}
          BadgeProps={{
            color: 'error',
          }}
          selected={selected}
          sx={{ width: '45px', height: '45px' }}
        >
          <NotificationIcon device={device} />
          {icon}
        </ButtonIcon>
      )}
    </React.Fragment>
  );
}

export default DeviceAlarmsAction;
